import { CostCenterCriteriaModel } from './cost-center-criteria.model';
import { CompanyModel } from './company.model';
import { ReferentialEntityStateModel } from './referential-entity-state.model';

export class CostCenterModel {
  public id: number = null;
  public code: string = null;
  public companyId: number = null;
  public company: CompanyModel = null;
  public doubling = false;
  public entityStateDto: ReferentialEntityStateModel = null;
  public label: string = null;
  public criterias: CostCenterCriteriaModel[] = null;
  public formattedLabel: string;

  public formattedString: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: CostCenterModel[] = [];
    jsons.forEach(json => {
      refs.push(new CostCenterModel().fromJSON(json));
    });
    return refs;
  }
}
